module.exports = __webpack_public_path__ + "static/media/bd_bg.9aa0016c.png";